//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headType: {
      type: Number,
      default: 0
    },
    isFixed: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    _back() {
      if ( this.$route.path === '/withdraw/audit') {
        this.$router.push({path: '/My'})
      } else if (this.$route.path === '/withdraw/main') {
        this.$router.push({path: '/withdraw/audit'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/p-header/index.vue